var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#030659"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7375 5.00923C22.0089 5.62942 21.2023 6.10377 20.3486 6.41401C19.8904 5.7782 19.2814 5.32755 18.6041 5.12302C17.9268 4.91848 17.2137 4.96993 16.5614 5.2704C15.9091 5.57088 15.349 6.10588 14.9568 6.80305C14.5647 7.50021 14.3594 8.32591 14.3687 9.16847V10.0866C13.0317 10.1285 11.7069 9.77061 10.5123 9.04493C9.31763 8.31925 8.29023 7.24828 7.52159 5.92739C7.52159 5.92739 4.47841 14.1908 11.3256 17.8634C9.75872 19.1469 7.89221 19.7905 6 19.6997C12.8471 24.2905 21.2159 19.6997 21.2159 9.14092C21.2152 8.88518 21.1948 8.63006 21.155 8.37886C21.9315 7.45473 22.4794 6.28796 22.7375 5.00923V5.00923Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter2);
export default __webpack_public_path__ + "static/media/twitter-2.470e8f3fcf4e4c9d8f24521051985390.svg";
export { ForwardRef as ReactComponent };